import React from 'react'
import {
	Row
}from 'antd'

import 'antd/lib/row/style/css'

import './style.css'

const CustomMenu = ({ children, selectedKey }) => {
	return (
		<Row className="custom-menu">
			{
				children?.map(x => {
					if (selectedKey == x?.key)
						return React.cloneElement(x, { className: " active" })
					return x
				})
			}
		</Row>
	)
}
export default CustomMenu